export default {
    January: { en: "January", uk: "Січня", pl: "Styczeń" },
    February: { en: "February", uk: "Лютого", pl: "Luty" },
    March: { en: "March", uk: "Березня", pl: "Marzec" },
    April: { en: "April", uk: "Квітня", pl: "Kwiecień" },
    May: { en: "May", uk: "Травня", pl: "Maj" },
    June: { en: "June", uk: "Червня", pl: "Czerwiec" },
    July: { en: "July", uk: "Липня", pl: "Lipiec" },
    August: { en: "August", uk: "Серпня", pl: "Sierpień" },
    September: { en: "September", uk: "Вересня", pl: "Wrzesień" },
    October: { en: "October", uk: "Жовтня", pl: "Październik" },
    November: { en: "November", uk: "Листопада", pl: "Listopad" },
    December: { en: "December", uk: "Грудня", pl: "Grudzień" },
};
